import React from 'react';
import { Link } from 'react-router-dom';
import {
  Typography,
  Grid,
  Paper,
  Button,
  Divider,
} from '@material-ui/core';
import HomeFeatured from './HomeFeatured';

/*
  acces theme from muithemeprovider??
*/
const style = {
  toolbar: {
    height: '80px',
  },
  logo: {
    marginLeft: 'auto',
    marginRight: 'auto',
    height: '60px',
    marginTop: '10px',
  },
  menu: {
    listStyle: 'none',
    margin: '0',
    padding: '0',
    border: '0',
    fontSize: '100%',
    font: 'inherit',
    verticalAlign: 'baseline',
    display: 'flex',
  },
  menuItem: {
    flex: 1,
    marginLeft: '16px',
    marginRight: '16px',
    height: '80px',
    alignItems: 'center',
  },
  subPromotion: {
    padding: '16px',
  },
  content: {
    padding: '16px',
  },
};

export default function Home() {
  return (
    <React.Fragment>
      <HomeFeatured />
      <div className="content">
        <Grid container justify="center" spacing={16}>
          <Grid sm={12} md={8} key="news" item>
            <Paper style={style.content} square>
              <h2>La légende de BloodyBattle</h2>
              <p>
                BloodyBattle est probablement le plus vieux serveur Minecraft francophone encore
                  ouvert.<br />
                Créé en décembre 2011 par un jeune collégien sous la forme d{"'"}un
                serveur Faction hébergé sur sa propre machine (avec Hamachi).
              </p>
              <p style={{ textAlign: 'center' }}>
                <i>Des millions de joueurs ont découvert Minecraft sur BloodyBattle</i>
              </p>
              <p>
                Le staff à rapidement créé de nombreux serveurs avec des jeux innédits que vous
                  connaissez tous à présent pour finalement évoluer sous la forme d{"'"}un network
                (la base de nos jours).
              </p>
              <p style={{ textAlign: 'center' }}>
                <i>Une communauté Minecraft extraordinaire</i>
              </p>
              <p>
                Si vous êtes débutants, vous serez guidé par des messages en jeu et des tutoriels
                  optionnels.<br />Lors de vos connexions, vous recevez des notificaitons sur les
                derniers changements importants.
              </p>
              <Divider style={{ margin: '24px 0' }} />
              <h2>News</h2>
              <p>
                On n{"'"}a pas le temps de niaiser à faire de beaux articles.
                On préfère vous porposer une expérience de jeu unique.
              </p>
              <Typography variant="body1" align="justify">
                Donc la meilleure manière d{"'"}être informé sur les avancées du serveur est de
                s{"'"}y connecter régulièrement et de discuter avec la communauté sur le Forum,
                Teamspeak ou Discord.<br />Il n{"'"}y a que ça de vrai pour apprendre rapidement
                les trucs et astuces du serveur.
              </Typography>
            </Paper>
          </Grid>
          <Grid container sm={12} md={4} spacing={16} item>
            <Grid xs={12} sm={6} md={12} key="community" item>
              <Paper style={style.content} square>
                <h2>Communauté</h2>
                <p>
                  Discutez avec la communauté en vocal ou par chat sur
                  les channels sur discord.
                </p>
                <Button href="https://discord.gg/YC4XPGp" className="bButton discord" fullWidth>
                  Rejoindre Discord
                </Button>
                <Button href="#" className="bButton teamspeak" fullWidth variant="contained">
                  Discuter sur Teamspeak
                </Button>
                <Button href="#" className="bButton forum" fullWidth>Participer sur le Forum</Button>
              </Paper>
            </Grid>
            <Grid xs={12} sm={6} md={12} key="server" item>
              <Paper style={style.content} square>
                <h2>Serveur Minecraft</h2>
                <p>
                  Le serveur est accessible à tous gratuitement!
                </p>
                <ul>
                  <li>IP: <i>bloodybattle.net</i></li>
                  <li>Accès: <i>premium et non-premium</i></li>
                  <li>Version: <i>1.8 à 1.16</i></li>
                  <li>Edition: <i>Java sur PC et Mac</i></li>
                </ul>
                <Link to="/">Se connecter au serveur</Link>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/home/Home.js